export enum NEW_USER_ACTION_TYPES {
	SET_NEW_USER_ROLES = 'SET_NEW_USER_ROLES',
	CLEAR_NEW_USER_ROLES = 'CLEAR_NEW_USER_ROLES',
	SET_NEW_USER_AVA = 'SET_NEW_USER_AVA',
	SET_NEW_USER_CV = 'SET_NEW_USER_CV',
}

interface NewUserRolesAction {
	type: NEW_USER_ACTION_TYPES.SET_NEW_USER_ROLES
	payload: string[]
}
interface NewUserAvaAction {
	type: NEW_USER_ACTION_TYPES.SET_NEW_USER_AVA
	payload: string
}
interface NewUserCvAction {
	type: NEW_USER_ACTION_TYPES.SET_NEW_USER_CV
	payload: string
}
interface ClearNewUserRolesAction {
	type: NEW_USER_ACTION_TYPES.CLEAR_NEW_USER_ROLES
	payload: string[]
}


export interface NewUserState {
	roles: string[]
	ava: string
	cv: string
}

const initialState: NewUserState = {
	roles: [],
	ava: '',
	cv: '',
}

type newUserActions =
	| NewUserRolesAction
	| ClearNewUserRolesAction
	| NewUserAvaAction
	| NewUserCvAction

export default (state = initialState, action: newUserActions): NewUserState => {
	switch (action.type) {
		case NEW_USER_ACTION_TYPES.SET_NEW_USER_ROLES: {
			return {
				...state,
				roles: action.payload || [],
			}
		}
		case NEW_USER_ACTION_TYPES.CLEAR_NEW_USER_ROLES: {
			return {
				...state,
				roles: []
			}
		}
		case NEW_USER_ACTION_TYPES.SET_NEW_USER_AVA: {
			return {
				...state,
				ava: action.payload
			}
		}
		case NEW_USER_ACTION_TYPES.SET_NEW_USER_CV: {
			return {
				...state,
				cv: action.payload
			}
		}
		default: {
			return state
		}
	}
}
